import { HttpClient } from '@angular/common/http';
import { inject,Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { StatusApi } from '@core/api/status/api';

import {
  BulkJobActionBody,
  BulkJobActionResponse,
  JobActionResponse,
  JobDetail,
  JobLogsResponse,
  JobsListParams,
  JobsListResponse,
  QueuesOverviewResponse,
  SingleJobActionBody,
} from '@core/api/status/types';

@Injectable({
  providedIn: 'root',
})
export class QueueAdminService {
  private readonly http = inject(HttpClient);

  getQueues(group?: string): Observable<QueuesOverviewResponse> {
    const { url } = StatusApi.getQueues(group);
    return this.http.get<QueuesOverviewResponse>(url);
  }

  getJobs(params: JobsListParams = {}): Observable<JobsListResponse> {
    const { url } = StatusApi.getJobs(params);
    return this.http.get<JobsListResponse>(url);
  }

  getJob(jobId: string, queue?: string): Observable<JobDetail> {
    const { url } = StatusApi.getJob(jobId, queue);
    return this.http.get<JobDetail>(url);
  }

  getJobLogs(jobId: string, queue?: string): Observable<JobLogsResponse> {
    const { url } = StatusApi.getJobLogs(jobId, queue);
    return this.http.get<JobLogsResponse>(url);
  }

  runJobAction(jobId: string, body: SingleJobActionBody): Observable<JobActionResponse> {
    const { url, body: payload } = StatusApi.runJobAction(jobId, body);
    return this.http.post<JobActionResponse>(url, payload);
  }

  runBulkJobAction(body: BulkJobActionBody): Observable<BulkJobActionResponse> {
    const { url, body: payload } = StatusApi.runBulkJobAction(body);
    return this.http.post<BulkJobActionResponse>(url, payload);
  }
}
